import { Component, OnInit } from '@angular/core';
import { TransmittalTemplateComponent } from '../../transmittal-template/transmittal-template.component';

@Component({
  selector: 'app-hci-transmittal',
  templateUrl: './hci-transmittal-template.component.html',
  styleUrls: ['./hci-transmittal-template.component.css']
})
export class HCITransmittalTemplateComponent implements TransmittalTemplateComponent, OnInit {

  constructor() { }
  templateName!: string;
  message_id?: number;
  to!: string;
  date!: string;
  edrcRef!: string;
  cusRef!: string;
  projName!: string;
  subject!: string;
  attention!: string;
  docDetails!: any[];
  distributionDetails!: any[];
  message_No?: any;

  ngOnInit() {
  }

  getDatePart(type:string){
    let result:any;
    let dateParts:string[] = this.date.split('-');
    switch(type){
      case 'date':
        result = dateParts[0];
        break;
      case 'month':
        result = dateParts[1];
        break;
      case 'year':
        result = dateParts[2];
        break;
    }
    return result;
  }

}
